import React from "react";
import { cn } from "../../lib/cn";

export function Card({
  title,
  extra,
  children,
  className,
  bordered = true,
  hoverable,
  loading,
  style,
  onClick,
}) {
  return (
    <div
      style={style}
      role={onClick ? "button" : undefined}
      onClick={onClick}
      onKeyDown={
        onClick
          ? (e) =>
              (e.key === "Enter" || e.key === " ") &&
              (e.preventDefault(), onClick(e))
          : undefined
      }
      tabIndex={onClick ? 0 : undefined}
      className={cn(
        "rounded-2xl bg-white shadow-sm overflow-hidden",
        bordered ? "border border-slate-200/80" : "border-0 shadow-none",
        hoverable &&
          "cursor-pointer transition hover:-translate-y-0.5 hover:shadow-md",
        className
      )}
    >
      {(title != null || extra != null) && (
        <div className="flex items-center justify-between border-b border-slate-100 px-5 py-3">
          {title != null ? (
            <span className="font-semibold text-slate-900">{title}</span>
          ) : (
            <span />
          )}
          {extra}
        </div>
      )}
      <div className="relative p-5">
        {loading ? (
          <div className="absolute inset-0 z-10 flex items-center justify-center rounded-b-2xl bg-white/70">
            <span className="h-8 w-8 animate-spin rounded-full border-2 border-brand border-t-transparent" />
          </div>
        ) : null}
        {children}
      </div>
    </div>
  );
}

/** Ant Design–style grid cell inside `Card` (service list tiles, etc.) */
export function CardGrid({ children, className, style, onClick }) {
  return (
    <div
      className={cn(
        "box-border w-full border-b border-slate-100/80 py-3 transition last:border-b-0",
        onClick && "cursor-pointer hover:bg-slate-50",
        className
      )}
      style={style}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) =>
              (e.key === "Enter" || e.key === " ") &&
              (e.preventDefault(), onClick(e))
          : undefined
      }
    >
      {children}
    </div>
  );
}

Card.Grid = CardGrid;